module.exports = __webpack_public_path__ + "img/heart.b500f222.svg";